import { StoreType } from "@apis/index";
import { deletesvg, edit } from "@assets/icons";
import Column from "@components/column";
import Table from "@components/table";
import { RootState } from "@store/index";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useConfig from "@hooks/useConfig";
import { useModal } from "@context/ModalContext";
import DeleteModal from "@components/delete-modal";
import { FaStore } from "react-icons/fa";
import StoreModal from "./StoreModal";

const StoreTypeTable = ({ moduleId }) => {
  const {
    data: storeTypes,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.storeTypes);
  const { bucketUrl } = useConfig();
  const { showModal } = useModal();
  const [page, setPage] = useState(1);

  const fetchStoreTypes = useCallback(async () => {
    await StoreType.list({
      state: "storeTypes",
      params: { page, moduleId },
    });
  }, [moduleId, page]);

  useEffect(() => {
    if (moduleId) fetchStoreTypes();
  }, [page, moduleId, fetchStoreTypes]);

  const columns = [
    {
      title: "SN",
      key: "sn",
      render: (_item: any, index: number) => index + 1,
    },
    {
      title: "Module",
      key: "module",
      render: (item: any) => item.module?.name || "-",
    },
    {
      title: "Icon",
      key: "icon",
      render: (item: any) =>
        item.icon ? (
          <img
            src={`${bucketUrl}/${item.icon}`}
            alt={item.name}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        ) : (
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "8px",
              background: "#f3f4f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              fontWeight: 600,
              color: "#6b7280",
              textTransform: "uppercase",
              border: "1px solid #e5e7eb",
            }}
          >
            {item.name?.charAt(0) || "-"}
          </div>
        ),
    },
    {
      title: "StoreType Name",
      key: "name",
      render: (item: any) => item.name?.toUpperCase() || "-",
    },
  ];
  const navigate = useNavigate();
  return (
    <Column>
      <Table
        columns={columns}
        data={storeTypes}
        totalItems={totalItems}
        totalPages={totalPages}
        pageControlled={page}
        onPageChange={setPage}
        // itemsPerPage={10}
        text="StoreTypes List"
        actions={[
          {
            key: "edit",
            icon: edit,
            onClick: (item) => {
              navigate(`/admin/users/store/update-store-type/${item.id}`, {
                state: item,
              });
            },
          },
          {
            key: "delete",
            icon: deletesvg,
            onClick: async (item) => {
              showModal(
                <DeleteModal
                  state="ignore_redux_update"
                  api={StoreType}
                  id={item.id}
                  onSuccess={fetchStoreTypes}
                />
              );
            },
          },
          {
            key: "stores",
            icon: <FaStore size={20} color="#4A4A4A" />,
            onClick: (item) => {
              showModal(
                <StoreModal typeId={item.id} moduleId={item.module.id} />,
                { width: 900 },
              );
            },
          },
        ]}
      />
    </Column>
  );
};

export default StoreTypeTable;
